import { Navigate } from 'react-router-dom';
import { selectIsAttached, useAuthStore } from '@/stores/useAuthStore';

export function RootRedirect() {
  const attached = useAuthStore(selectIsAttached);
  // Phase 5.5c·5.5d: admin 이고 MFA 미활성 → /mfa/setup 강제 (가드)
  const mfaSetupRequired = useAuthStore((s) => s.user?.mfa_setup_required);
  if (mfaSetupRequired) return <Navigate to="/mfa/setup" replace />;
  return <Navigate to={attached ? '/dashboard' : '/find-org'} replace />;
}
